import React, { useState } from 'react'
import './DaGa.scss'
import {
  getFromlocalstorage,
  getFromsessionstorage
} from '../../../../component/MaHoaDuLieu/MaHoaDuLieu'
import { getApiUrl } from '../../../../api/api'
import Loading from '../../../../component/Loading/Loading'
import Notify from '../../../../component/Notify/Notify'

const liveItems = [
  {
    id: 'AWC_S',
    name: 'Sexy',
    logo: '/daga/ws168-logo.png',
    titleImg: '/daga/ws168-info.png',
    picImg: '/daga/ws168.png',
    goGameParam: ['AWC_S', 'AWC_S'],
    portfolio: 'ThirdPartySportsBook',
    gameproviderid: '1070',
    gameid: '0'
  }
]

const DaGa = () => {
  const [activeIndex, setActiveIndex] = useState(0)
  const [isLoading, setisLoading] = useState(false)
  const dangnhap = localStorage.getItem('dangnhap')
  const [notiMessage, setNotiMessage] = useState('')

  const device = window.innerWidth > 540 ? 'd' : 'm'
  const userdata =
    JSON.parse(getFromsessionstorage('data_u')) ||
    JSON.parse(getFromlocalstorage('data_u'))

  const handleTabClick = index => {
    setActiveIndex(index)
  }

  const hanldePostWidthdraw = async (portfolio, gameProviderId, gameId) => {
    try {
      setisLoading(true)
      const response = await fetch(`${getApiUrl('backend')}/launch_game`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          portfolio,
          device,
          gameProviderId,
          gameId,
          userData: userdata,
          productId: null
        })
      })
      const data = await response.json()
      console.log(data)

      if (data.message) {
        setisLoading(false)
        alert(data.message)
      } else {
        if (data.url) {
          window.location.href = data.url
          setisLoading(false)
        }
      }
    } catch (error) {
      setisLoading(false)
      console.error('Failed to fetch API: ', error)
    }
  }

  return (
    <>
      {notiMessage && (
        <Notify
          message={notiMessage}
          setcontent={setNotiMessage}
          type='error'
        />
      )}

      <Loading isLoading={isLoading} />
      <div className='live-boxdaga'>
        <div className='containerdaga wrapdaga'>
          <div
            id='liveList'
            className='live-gamedaga tabdaga tab-slideshowdaga'
          >
            <div className='tabframedaga'>
              <div className='swiper-containerdaga'>
                <div className='tab_ctrldaga ctrldaga swiper-wrapperdaga'>
                  {liveItems.map((item, index) => (
                    <a
                      key={item.id}
                      className={`swiper-slidedaga tab_btndaga ${
                        index === activeIndex ? 'activedaga' : ''
                      }`}
                      href='#!'
                      onClick={() => handleTabClick(index)}
                    >
                      <img
                        src={item.logo}
                        alt={`${item.name}-logo`}
                        className='live-provider-logo-imgdaga'
                      />
                      <span className='namedaga'>{item.name}</span>
                    </a>
                  ))}
                </div>
              </div>
            </div>
            <div className='tab_maindaga maindaga'>
              {liveItems.map((item, index) => (
                <div
                  key={item.id}
                  className={`tab_itemdaga itemdaga ${
                    index === activeIndex ? 'activedaga' : ''
                  }`}
                  style={{ display: index === activeIndex ? 'flex' : 'none' }}
                >
                  <div className='content-boxdaga animateddaga fadeInLeftdaga'>
                    <img
                      src={item.titleImg}
                      alt={item.name}
                      className='live-provider-imgdaga'
                    />
                    <a
                      className='play-btndaga'
                      href='#!'
                      onClick={() => {
                        if (!dangnhap) {
                          setNotiMessage('Vui lòng đăng nhập để chơi game')
                        } else {
                          hanldePostWidthdraw(
                            item.portfolio,
                            item.gameproviderid,
                            item.gameid
                          )
                        }
                      }}
                    >
                      PLAY NOW
                    </a>
                  </div>
                  <div className='picdaga animateddaga fadeInRightdaga'>
                    <img src={item.picImg} alt={item.name} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DaGa
